// Import model
import { CreateContactNoteRequest } from '../models/CreateContactNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateContactNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateContactNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateContactNoteRequest instance
   */
  static deserialize(json: string): CreateContactNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateContactNoteRequest instance
   */
  static fromObject(obj: any): CreateContactNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateContactNoteRequest');
    }


    const instance: CreateContactNoteRequest = {
      parentObjectId: obj['parentObjectId'] as string,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string,
      type_: obj['type'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateContactNoteRequest instances
   */
  static deserializeArray(json: string): CreateContactNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateContactNoteRequest instance to a JSON string
   */
  static serialize(instance: CreateContactNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateContactNoteRequest instance to a plain object
   */
  static toObject(instance: CreateContactNoteRequest): any {
    return {
      'parentObjectId': instance.parentObjectId,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'description': instance.description,
      'name': instance.name,
      'type': instance.type_,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateContactNoteRequest instances to a JSON string
   */
  static serializeArray(instances: CreateContactNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
